if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
      }
      this.mql = window.matchMedia('(min-width: 750px)');
      // Direkt nach dem Laden (z. B. Weiterleitung aus der Product-Highlight-Bar mit
      // automatischer Varianten-/Bundle-Auswahl) das automatische Scrollen des
      // Thumbnail-Streifens unterdruecken, damit dieser bei Bild 1 startet.
      // Freigabe, sobald der Kunde selbst interagiert (Klick/Taste/Touch).
      this._suppressThumbScroll = true;
      var releaseSuppress = () => {
        this._suppressThumbScroll = false;
        document.removeEventListener('pointerdown', releaseSuppress, true);
        document.removeEventListener('keydown', releaseSuppress, true);
        document.removeEventListener('touchstart', releaseSuppress, true);
      };
      document.addEventListener('pointerdown', releaseSuppress, true);
      document.addEventListener('keydown', releaseSuppress, true);
      document.addEventListener('touchstart', releaseSuppress, true);
      // CSS-Zentrierung des Thumbnail-Streifens entschaerfen: bei Ueberlauf (schmales Fenster)
      // wird der Inhalt sonst zentriert und die ersten Bilder nach links aus dem sichtbaren
      // Bereich gedraengt (nicht erreichbar). 'safe center' richtet bei Ueberlauf linksbuendig
      // aus (scrollbar ab Bild 1) und zentriert nur, wenn alles hineinpasst.
      if (this.elements.thumbnails) {
        var _tl = this.elements.thumbnails.querySelector('[id^="Slider-Thumbnails"]');
        if (_tl) {
          _tl.style.justifyContent = 'flex-start';
          _tl.style.justifyContent = 'safe center';
        }
      }
      this.reorderToNaturalOrder();
      if (!this.elements.thumbnails) return;

      this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
      this.elements.viewer.addEventListener("click", this._onClickFunc.bind(this));
      this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
        mediaToSwitch.querySelector('button').addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
      });
      if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
    }

    // Stellt die Produktbilder beim Laden in ihre tatsaechliche Reihenfolge (Position) her,
    // damit ein per Link vorausgewaehltes Varianten-Bild den Bildstreifen nicht ans Ende schiebt.
    reorderToNaturalOrder() {
      try {
        var path = window.location.pathname;
        var idx = path.indexOf('/products/');
        if (idx === -1) return;
        var handle = path.slice(idx + 10).split('/')[0].split('?')[0];
        if (!handle) return;

        var self = this;
        var mediaIdOf = function (el) {
          var v = (el.dataset.mediaId || el.dataset.target || '');
          var dash = v.lastIndexOf('-');
          return dash === -1 ? v : v.slice(dash + 1);
        };

        fetch('/products/' + handle + '.js', { headers: { 'Accept': 'application/json' } })
          .then(function (res) { return res.ok ? res.json() : null; })
          .then(function (data) {
            if (!data || !data.media) return;
            var order = {};
            data.media.forEach(function (m, i) { order[String(m.id)] = i; });

            var sortList = function (listEl, itemSelector) {
              if (!listEl) return;
              var items = Array.prototype.slice.call(listEl.querySelectorAll(itemSelector));
              items.sort(function (a, b) {
                var oa = order[mediaIdOf(a)];
                var ob = order[mediaIdOf(b)];
                if (oa === undefined) oa = 9999;
                if (ob === undefined) ob = 9999;
                return oa - ob;
              });
              items.forEach(function (it) { listEl.appendChild(it); });
            };

            var viewerList = self.elements.viewer && self.elements.viewer.querySelector('[id^="Slider-Gallery"]');
            sortList(viewerList, ':scope > li[data-media-id]');

            if (self.elements.thumbnails) {
              var thumbList = self.elements.thumbnails.querySelector('[id^="Slider-Thumbnails"]');
              sortList(thumbList, ':scope > li[data-target]');
              if (self.elements.thumbnails.slider) {
                self.elements.thumbnails.slider.scrollTo({ left: 0 });
              }
              if (typeof self.elements.thumbnails.resetPages === 'function') self.elements.thumbnails.resetPages();
            }
            if (self.elements.viewer && typeof self.elements.viewer.resetPages === 'function') self.elements.viewer.resetPages();
          })
          .catch(function () {});
      } catch (e) {}
    }

    _onClickFunc(event) {
      if(event.offsetX > this.offsetWidth / 2) {
        let val = false;
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch, index) => {
           if(mediaToSwitch.querySelector('button').getAttribute('aria-current') && val == false && index < this.elements.thumbnails.querySelectorAll('[data-target]').length - 1 ) {
            let nextEle = this.elements.thumbnails.querySelectorAll('[data-target]')[index+1];
            this.setActiveMedia(nextEle.dataset.target, false);
            val = true;
           }
        });
      }else {
        let val = false;
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch, index) => {
           if(mediaToSwitch.querySelector('button').getAttribute('aria-current') && val == false && index > 0 ) {
            let nextEle = this.elements.thumbnails.querySelectorAll('[data-target]')[index-1];
            this.setActiveMedia(nextEle.dataset.target, false);
            val = true;
           }
      });
    }
    }
    onSlideChanged(event) {
      const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${ event.detail.currentElement.dataset.mediaId }"]`);
      this.setActiveThumbnail(thumbnail);
    }

    setActiveMedia(mediaId, prepend) {
      // Nie mehr das aktive/Varianten-Bild an den Anfang ziehen: natuerliche Reihenfolge beibehalten.
      prepend = false;
      const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${ mediaId }"]`);
      this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });
      activeMedia.classList.add('is-active');

      if (prepend) {
        activeMedia.parentElement.prepend(activeMedia);
        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
          activeThumbnail.parentElement.prepend(activeThumbnail);
        }
        if (this.elements.viewer.slider) this.elements.viewer.resetPages();
      }

      this.preventStickyHeader();
      window.setTimeout(() => {
        if (this.elements.thumbnails) {
          activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
        }
        if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
          activeMedia.scrollIntoView({behavior: 'smooth'});
        }
      });
      this.playActiveMedia(activeMedia);

      if (!this.elements.thumbnails) return;
      const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
      this.setActiveThumbnail(activeThumbnail);
      this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
    }

    setActiveThumbnail(thumbnail) {
      if (!this.elements.thumbnails || !thumbnail) return;

      this.elements.thumbnails.querySelectorAll('button').forEach((element) => element.removeAttribute('aria-current'));
      thumbnail.querySelector('button').setAttribute('aria-current', true);
      if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;
      // Automatisches Scrollen kurz nach dem Laden unterdruecken (Streifen bleibt bei Bild 1).
      if (this._suppressThumbScroll) return;

      this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
    }

    announceLiveRegion(activeItem, position) {
      const image = activeItem.querySelector('.product__modal-opener--image img');
      if (!image) return;
      image.onload = () => {
        this.elements.liveRegion.setAttribute('aria-hidden', false);
        this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace(
          '[index]',
          position
        );
        setTimeout(() => {
          this.elements.liveRegion.setAttribute('aria-hidden', true);
        }, 2000);
      };
      image.src = image.src;
    }

    playActiveMedia(activeItem) {
      window.pauseAllMedia();
      const deferredMedia = activeItem.querySelector('.deferred-media');
      if (deferredMedia) deferredMedia.loadContent(false);
    }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    removeListSemantic() {
      if (!this.elements.viewer.slider) return;
      this.elements.viewer.slider.setAttribute('role', 'presentation');
      this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
    }
  });
}
